import rules from '~/permission/rules'
import { PERMISSIONS, FeatureMatrixSelectorsType } from '~/types'

const HasPermission = (permission: PERMISSIONS, featureMatrix: FeatureMatrixSelectorsType) => {
  const { role } = featureMatrix

  const hasStaticPermission = role && rules[role]?.static.includes(permission)
  const hasDynamicPermission = role && rules[role]?.dynamic[permission]?.(featureMatrix)

  return hasStaticPermission || hasDynamicPermission
}

export default HasPermission
